/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiIntegrationsDtoMemberDataMismatchDto } from './WebApiIntegrationsDtoMemberDataMismatchDto';
import {
    WebApiIntegrationsDtoMemberDataMismatchDtoFromJSON,
    WebApiIntegrationsDtoMemberDataMismatchDtoFromJSONTyped,
    WebApiIntegrationsDtoMemberDataMismatchDtoToJSON,
} from './WebApiIntegrationsDtoMemberDataMismatchDto';
import type { WebApiIntegrationsDtoMemberStatusMismatchDto } from './WebApiIntegrationsDtoMemberStatusMismatchDto';
import {
    WebApiIntegrationsDtoMemberStatusMismatchDtoFromJSON,
    WebApiIntegrationsDtoMemberStatusMismatchDtoFromJSONTyped,
    WebApiIntegrationsDtoMemberStatusMismatchDtoToJSON,
} from './WebApiIntegrationsDtoMemberStatusMismatchDto';
import type { WebApiIntegrationsDtoMissingMemberDto } from './WebApiIntegrationsDtoMissingMemberDto';
import {
    WebApiIntegrationsDtoMissingMemberDtoFromJSON,
    WebApiIntegrationsDtoMissingMemberDtoFromJSONTyped,
    WebApiIntegrationsDtoMissingMemberDtoToJSON,
} from './WebApiIntegrationsDtoMissingMemberDto';
import type { WebApiIntegrationsObjectsIntegrationType } from './WebApiIntegrationsObjectsIntegrationType';
import {
    WebApiIntegrationsObjectsIntegrationTypeFromJSON,
    WebApiIntegrationsObjectsIntegrationTypeFromJSONTyped,
    WebApiIntegrationsObjectsIntegrationTypeToJSON,
} from './WebApiIntegrationsObjectsIntegrationType';

/**
 * 
 * @export
 * @interface WebApiIntegrationsDtoMemberSyncReportDto
 */
export interface WebApiIntegrationsDtoMemberSyncReportDto {
    /**
     * 
     * @type {number}
     * @memberof WebApiIntegrationsDtoMemberSyncReportDto
     */
    companyId?: number;
    /**
     * 
     * @type {WebApiIntegrationsObjectsIntegrationType}
     * @memberof WebApiIntegrationsDtoMemberSyncReportDto
     */
    integrationType?: WebApiIntegrationsObjectsIntegrationType;
    /**
     * 
     * @type {number}
     * @memberof WebApiIntegrationsDtoMemberSyncReportDto
     */
    totalMembers?: number;
    /**
     * 
     * @type {number}
     * @memberof WebApiIntegrationsDtoMemberSyncReportDto
     */
    totalExternalMembers?: number;
    /**
     * 
     * @type {Array<WebApiIntegrationsDtoMissingMemberDto>}
     * @memberof WebApiIntegrationsDtoMemberSyncReportDto
     */
    missingInIntegration?: Array<WebApiIntegrationsDtoMissingMemberDto> | null;
    /**
     * 
     * @type {Array<WebApiIntegrationsDtoMemberDataMismatchDto>}
     * @memberof WebApiIntegrationsDtoMemberSyncReportDto
     */
    dataMismatches?: Array<WebApiIntegrationsDtoMemberDataMismatchDto> | null;
    /**
     * 
     * @type {Array<WebApiIntegrationsDtoMemberStatusMismatchDto>}
     * @memberof WebApiIntegrationsDtoMemberSyncReportDto
     */
    statusMismatches?: Array<WebApiIntegrationsDtoMemberStatusMismatchDto> | null;
}

/**
 * Check if a given object implements the WebApiIntegrationsDtoMemberSyncReportDto interface.
 */
export function instanceOfWebApiIntegrationsDtoMemberSyncReportDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiIntegrationsDtoMemberSyncReportDtoFromJSON(json: any): WebApiIntegrationsDtoMemberSyncReportDto {
    return WebApiIntegrationsDtoMemberSyncReportDtoFromJSONTyped(json, false);
}

export function WebApiIntegrationsDtoMemberSyncReportDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiIntegrationsDtoMemberSyncReportDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'companyId': !exists(json, 'companyId') ? undefined : json['companyId'],
        'integrationType': !exists(json, 'integrationType') ? undefined : WebApiIntegrationsObjectsIntegrationTypeFromJSON(json['integrationType']),
        'totalMembers': !exists(json, 'totalMembers') ? undefined : json['totalMembers'],
        'totalExternalMembers': !exists(json, 'totalExternalMembers') ? undefined : json['totalExternalMembers'],
        'missingInIntegration': !exists(json, 'missingInIntegration') ? undefined : (json['missingInIntegration'] === null ? null : (json['missingInIntegration'] as Array<any>).map(WebApiIntegrationsDtoMissingMemberDtoFromJSON)),
        'dataMismatches': !exists(json, 'dataMismatches') ? undefined : (json['dataMismatches'] === null ? null : (json['dataMismatches'] as Array<any>).map(WebApiIntegrationsDtoMemberDataMismatchDtoFromJSON)),
        'statusMismatches': !exists(json, 'statusMismatches') ? undefined : (json['statusMismatches'] === null ? null : (json['statusMismatches'] as Array<any>).map(WebApiIntegrationsDtoMemberStatusMismatchDtoFromJSON)),
    };
}

export function WebApiIntegrationsDtoMemberSyncReportDtoToJSON(value?: WebApiIntegrationsDtoMemberSyncReportDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'companyId': value.companyId,
        'integrationType': WebApiIntegrationsObjectsIntegrationTypeToJSON(value.integrationType),
        'totalMembers': value.totalMembers,
        'totalExternalMembers': value.totalExternalMembers,
        'missingInIntegration': value.missingInIntegration === undefined ? undefined : (value.missingInIntegration === null ? null : (value.missingInIntegration as Array<any>).map(WebApiIntegrationsDtoMissingMemberDtoToJSON)),
        'dataMismatches': value.dataMismatches === undefined ? undefined : (value.dataMismatches === null ? null : (value.dataMismatches as Array<any>).map(WebApiIntegrationsDtoMemberDataMismatchDtoToJSON)),
        'statusMismatches': value.statusMismatches === undefined ? undefined : (value.statusMismatches === null ? null : (value.statusMismatches as Array<any>).map(WebApiIntegrationsDtoMemberStatusMismatchDtoToJSON)),
    };
}

